export interface VideoArticle {
  id: string;
  title: string;
  description: string;
  category: string;
  categoryName: string;
  imageUrl: string;
  duration: string;
  views: number;
  likes: number;
  date: string;
  author: string;
  tags: string[];
  content: string;
  featured: boolean;
}

export const videos: VideoArticle[] = [
  {
    id: 'v001',
    title: '北欧极简生活：打造舒适温馨的理想家居空间',
    description: '本期视频带你走进北欧极简风格的家居世界，从色彩搭配到家具选择，教你打造一个温馨又时尚的理想居所。',
    category: 'lifestyle',
    categoryName: '生活',
    imageUrl: 'https://readdy.ai/api/search-image?query=bright%20scandinavian%20living%20room%20with%20warm%20natural%20light%2C%20minimalist%20furniture%2C%20wooden%20floors%2C%20green%20plants%2C%20cozy%20textiles%2C%20neutral%20beige%20tones%2C%20editorial%20interior%20photography%2C%20clean%20composition&width=800&height=450&seq=featured-v001&orientation=landscape',
    duration: '12:35',
    views: 128000,
    likes: 8900,
    date: '2026-08-08',
    author: '小桃子',
    tags: ['家居', '极简', '北欧风', '装修'],
    content: '',
    featured: true,
  },
  {
    id: 'v002',
    title: '2026夏季音乐节全记录：最燃现场回顾',
    description: '直击2026夏季最热音乐节现场，从摇滚到电子，从白天到黑夜，带你感受最纯粹的音乐狂欢。',
    category: 'entertainment',
    categoryName: '娱乐',
    imageUrl: 'https://readdy.ai/api/search-image?query=energetic%20music%20festival%20at%20sunset%20with%20colorful%20stage%20lights%2C%20excited%20crowd%2C%20warm%20golden%20hour%20glow%2C%20atmospheric%20haze%2C%20editorial%20photography%2C%20vibrant%20yet%20warm%20tones&width=800&height=450&seq=featured-v002&orientation=landscape',
    duration: '18:22',
    views: 256000,
    likes: 15200,
    date: '2026-08-06',
    author: '蜜桃娱乐',
    tags: ['音乐节', '现场', '摇滚', '电子音乐'],
    content: '',
    featured: true,
  },
  {
    id: 'v003',
    title: '米其林大厨亲授：完美牛排的终极烹饪秘诀',
    description: '星级大厨手把手教你选肉、腌制、煎制全过程，让你在家也能做出餐厅级别的完美牛排。',
    category: 'food',
    categoryName: '美食',
    imageUrl: 'https://readdy.ai/api/search-image?query=perfectly%20cooked%20steak%20on%20wooden%20cutting%20board%20with%20fresh%20herbs%20and%20sea%20salt%2C%20warm%20ambient%20light%2C%20rustic%20kitchen%20setting%2C%20appetizing%20food%20photography%2C%20soft%20natural%20side%20lighting&width=800&height=450&seq=featured-v003&orientation=landscape',
    duration: '15:48',
    views: 198000,
    likes: 13400,
    date: '2026-08-05',
    author: '蜜桃厨房',
    tags: ['牛排', '烹饪', '美食教程', '西餐'],
    content: '',
    featured: true,
  },
  {
    id: 'v004',
    title: '独自背包游日本：京都古巷与奈良鹿鸣',
    description: '一个人的日本深度旅行，从京都的千年古寺到奈良的悠然鹿群，带你感受最地道的和风文化。',
    category: 'travel',
    categoryName: '旅行',
    imageUrl: 'https://readdy.ai/api/search-image?query=tranquil%20japanese%20temple%20garden%20in%20kyoto%20during%20autumn%2C%20maple%20trees%20with%20warm%20red%20and%20orange%20leaves%2C%20traditional%20wooden%20architecture%2C%20soft%20morning%20light%2C%20zen%20atmosphere%2C%20travel%20photography&width=800&height=450&seq=featured-v004&orientation=landscape',
    duration: '22:10',
    views: 312000,
    likes: 21800,
    date: '2026-08-03',
    author: '蜜桃旅行家',
    tags: ['日本', '京都', '旅行', '背包客'],
    content: '',
    featured: true,
  },
  {
    id: 'v005',
    title: 'Apple Vision Pro 深度评测：空间计算的未来已来',
    description: '两周深度体验Apple Vision Pro，从显示效果到交互体验，全面解析这款划时代产品的真实表现。',
    category: 'tech',
    categoryName: '科技',
    imageUrl: 'https://readdy.ai/api/search-image?query=sleek%20modern%20VR%20headset%20on%20minimalist%20desk%20with%20warm%20wood%20background%2C%20soft%20natural%20light%20from%20window%2C%20clean%20product%20photography%2C%20professional%20tech%20aesthetic%2C%20subtle%20shadows&width=800&height=450&seq=featured-v005&orientation=landscape',
    duration: '20:05',
    views: 445000,
    likes: 28700,
    date: '2026-08-01',
    author: '蜜桃科技',
    tags: ['Apple', 'Vision Pro', '评测', 'AR/VR'],
    content: '',
    featured: true,
  },
  {
    id: 'v006',
    title: '2026秋冬穿搭趋势：温暖色系的高级搭配法则',
    description: '提前解锁2026秋冬穿搭密码，从大地色到酒红色，教你用基础款穿出高级感。',
    category: 'fashion',
    categoryName: '时尚',
    imageUrl: 'https://readdy.ai/api/search-image?query=elegant%20autumn%20fashion%20layout%20with%20warm%20neutral%20toned%20clothing%2C%20wool%20textures%2C%20soft%20beige%20and%20terracotta%20colors%2C%20minimalist%20studio%20lighting%2C%20editorial%20fashion%20photography%2C%20clean%20composition&width=800&height=450&seq=trending-v006&orientation=landscape',
    duration: '14:30',
    views: 167000,
    likes: 11200,
    date: '2026-07-30',
    author: '蜜桃时尚',
    tags: ['穿搭', '秋冬', '时尚', '配色'],
    content: '',
    featured: false,
  },
  {
    id: 'v007',
    title: '晨间仪式感：5个让你元气满满一天的早起习惯',
    description: '分享五个简单有效的晨间习惯，从冥想、拉伸到营养早餐，帮你建立高效又健康的早晨流程。',
    category: 'lifestyle',
    categoryName: '生活',
    imageUrl: 'https://readdy.ai/api/search-image?query=serene%20morning%20bedroom%20scene%20with%20soft%20sunlight%20streaming%20through%20window%2C%20neatly%20made%20bed%20with%20white%20linen%2C%20glass%20of%20water%2C%20minimalist%20decor%2C%20warm%20peaceful%20atmosphere%2C%20editorial%20photography&width=800&height=450&seq=trending-v007&orientation=landscape',
    duration: '10:15',
    views: 98000,
    likes: 7200,
    date: '2026-07-28',
    author: '小桃子',
    tags: ['早起', '习惯', '生活方式', '自律'],
    content: '',
    featured: false,
  },
  {
    id: 'v008',
    title: '在家复刻米其林甜品：法式焦糖布丁的完美配方',
    description: '超详细步骤教你做出餐厅级别的法式焦糖布丁，丝滑绵密的口感让你爱上烘焙。',
    category: 'food',
    categoryName: '美食',
    imageUrl: 'https://readdy.ai/api/search-image?query=beautiful%20creme%20brulee%20with%20caramelized%20sugar%20top%20on%20elegant%20ceramic%20plate%2C%20warm%20candlelight%20ambiance%2C%20rustic%20wooden%20table%2C%20food%20photography%2C%20soft%20focus%2C%20golden%20tones&width=800&height=450&seq=trending-v008&orientation=landscape',
    duration: '13:55',
    views: 89000,
    likes: 6500,
    date: '2026-07-27',
    author: '蜜桃厨房',
    tags: ['甜品', '烘焙', '法式', '焦糖布丁'],
    content: '',
    featured: false,
  },
  {
    id: 'v009',
    title: '冰岛环岛自驾全攻略：极光、冰川与黑沙滩',
    description: '14天冰岛环岛自驾游记，从雷克雅未克到维克黑沙滩，带你领略地球上最像外星球的壮丽风景。',
    category: 'travel',
    categoryName: '旅行',
    imageUrl: 'https://readdy.ai/api/search-image?query=dramatic%20iceland%20landscape%20with%20northern%20lights%20over%20snowy%20mountains%2C%20aurora%20borealis%20in%20green%20and%20purple%2C%20dark%20sky%2C%20remote%20wilderness%2C%20cinematic%20travel%20photography%2C%20magical%20atmosphere&width=800&height=450&seq=trending-v009&orientation=landscape',
    duration: '25:40',
    views: 389000,
    likes: 26500,
    date: '2026-07-25',
    author: '蜜桃旅行家',
    tags: ['冰岛', '极光', '自驾', '环岛'],
    content: '',
    featured: false,
  },
  {
    id: 'v010',
    title: 'iPhone 17 Pro Max vs 三星S25 Ultra：旗舰对决',
    description: '2026年两大旗舰手机终极对决，从拍照到性能再到续航，帮你找到最适合的那一款。',
    category: 'tech',
    categoryName: '科技',
    imageUrl: 'https://readdy.ai/api/search-image?query=two%20premium%20smartphones%20side%20by%20side%20on%20clean%20white%20marble%20surface%2C%20minimalist%20product%20photography%2C%20soft%20natural%20lighting%2C%20professional%20tech%20aesthetic%2C%20subtle%20reflections&width=800&height=450&seq=trending-v010&orientation=landscape',
    duration: '19:30',
    views: 523000,
    likes: 35400,
    date: '2026-07-23',
    author: '蜜桃科技',
    tags: ['iPhone', '三星', '旗舰', '对比评测'],
    content: '',
    featured: false,
  },
  {
    id: 'v011',
    title: '胶囊衣橱挑战：30件单品穿出100种搭配',
    description: '极简主义者的穿搭哲学，用最少的单品创造最多的造型可能性，省钱又环保的时尚态度。',
    category: 'fashion',
    categoryName: '时尚',
    imageUrl: 'https://readdy.ai/api/search-image?query=minimalist%20capsule%20wardrobe%20display%20with%20neutral%20toned%20clothing%20on%20wooden%20hangers%2C%20organized%20closet%2C%20warm%20lighting%2C%20scandinavian%20aesthetic%2C%20clean%20and%20simple%20fashion%20photography&width=800&height=450&seq=trending-v011&orientation=landscape',
    duration: '16:20',
    views: 134000,
    likes: 9800,
    date: '2026-07-21',
    author: '蜜桃时尚',
    tags: ['胶囊衣橱', '极简', '穿搭', '环保'],
    content: '',
    featured: false,
  },
  {
    id: 'v012',
    title: '2026暑期档电影大盘点：这十部必看佳作别错过',
    description: '暑期档观影指南来啦！从国产大片到好莱坞巨制，为你精选十部最值得看的电影。',
    category: 'entertainment',
    categoryName: '娱乐',
    imageUrl: 'https://readdy.ai/api/search-image?query=classic%20cinema%20interior%20with%20warm%20red%20velvet%20seats%2C%20golden%20decorative%20details%2C%20soft%20dim%20lighting%2C%20nostalgic%20movie%20theater%20atmosphere%2C%20elegant%20photography%2C%20vintage%20charm&width=800&height=450&seq=trending-v012&orientation=landscape',
    duration: '11:45',
    views: 201000,
    likes: 14300,
    date: '2026-07-20',
    author: '蜜桃娱乐',
    tags: ['电影', '暑期档', '推荐', '院线'],
    content: '',
    featured: false,
  },
];